import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { useUploadImage } from 'libs/hooks/io/useUploadImage';
import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import { useEffect } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    resolution: EUploadResolution;
    worldMapId: string;
    onUploaded: (url: string) => void;
}

export const UploadImageButton = (props: Props) => {
    const { uploaded, setFiles, inProgress } = useUploadImage([props.resolution], props.worldMapId);

    useEffect(() => {
        if (!uploaded?.data?.imageUrls) {
            return;
        }

        props.onUploaded(uploaded.data.imageUrls[props.resolution]);
    }, [uploaded]);

    return (
        <S_UploadImageButton className={props.className}>
            <S_InputFile
                type="file"
                accept="image/x-png,image/png,image/gif,image/jpeg,image/jpg,image/heic,image/heif,image/svg+xml,.heic;capture=camera"
                onChange={(e) => {
                    setFiles(Array.from(e.target['files']));
                }}
            />
            <S_ActionButton
                text={inProgress ? Localization.UPLOADING + '...' : Localization.UPLOAD_ACTION}
                icon={{ iconName: 'upload' }}
                disabled={Boolean(inProgress)}
            />
        </S_UploadImageButton>
    );
};

const S_UploadImageButton = styled.div``;

const S_ActionButton = styled(ActionButton)``;

const S_InputFile = styled.input`
    display: none;
`;
